import React from 'react';

function CancellationModal({
    isOpen,
    onClose,
    cancellationData,
    onDataChange,
    onSubmit,
    isLoading,
    error,
    isSubmitted
}) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content cancellation-modal" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>×</button>
                <div className="ornament-top"></div>

                {isSubmitted ? (
                    <>
                        <h2 className="modal-title">✅ Richiesta Inviata</h2>
                        <div className="divider"></div>
                        <div className="modal-body">
                            <p className="modal-text">
                                La tua richiesta di cancellazione è stata ricevuta.
                            </p>
                            <p className="modal-text" style={{ marginTop: '15px' }}>
                                Mi dispiace tu non possa venire.
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <h2 className="modal-title">Cancellazione Partecipazione</h2>
                        <div className="divider"></div>
                        <div className="modal-body">
                            <p className="modal-text" style={{ marginBottom: '20px' }}>
                                Se hai già confermato ma non puoi più partecipare, inserisci i tuoi dati.
                            </p>

                            {error && <div className="error-message">{error}</div>}

                            <form onSubmit={onSubmit}>
                                <div className="form-group">
                                    <label htmlFor="cancel-nome">Nome</label>
                                    <input
                                        type="text"
                                        id="cancel-nome"
                                        name="nome"
                                        value={cancellationData.nome}
                                        onChange={onDataChange}
                                        required
                                        placeholder="Il tuo nome"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="cancel-cognome">Cognome</label>
                                    <input
                                        type="text"
                                        id="cancel-cognome"
                                        name="cognome"
                                        value={cancellationData.cognome}
                                        onChange={onDataChange}
                                        required
                                        placeholder="Il tuo cognome"
                                    />
                                </div>

                                <div className="form-group checkbox-group">
                                    <label className="checkbox-label">
                                        <input
                                            type="checkbox"
                                            name="hasPlusOne"
                                            checked={cancellationData.hasPlusOne}
                                            onChange={onDataChange}
                                        />
                                        <span style={{ marginLeft: '8px' }}>Anche il mio accompagnatore</span>
                                    </label>
                                </div>

                                {cancellationData.hasPlusOne && (
                                    <div className="plusone-section">
                                        <div className="form-group">
                                            <label htmlFor="cancel-nomePlusOne">Nome +1</label>
                                            <input
                                                type="text"
                                                id="cancel-nomePlusOne"
                                                name="nomePlusOne"
                                                value={cancellationData.nomePlusOne}
                                                onChange={onDataChange}
                                                required
                                                placeholder="Nome del +1"
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="cancel-cognomePlusOne">Cognome +1</label>
                                            <input
                                                type="text"
                                                id="cancel-cognomePlusOne"
                                                name="cognomePlusOne"
                                                value={cancellationData.cognomePlusOne}
                                                onChange={onDataChange}
                                                required
                                                placeholder="Cognome del +1"
                                            />
                                        </div>
                                    </div>
                                )}

                                <button
                                    type="submit"
                                    className="submit-button"
                                    disabled={isLoading || !cancellationData.nome || !cancellationData.cognome}
                                    style={{ marginTop: '20px' }}
                                >
                                    {isLoading ? 'Invio in corso...' : 'Invia Richiesta'}
                                </button>
                            </form>
                        </div>
                    </>
                )}

                <div className="ornament-bottom"></div>
            </div>
        </div>
    );
}

export default CancellationModal;
